var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconServingDomeOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.3314C24.1669 10.3314 28.1632 11.9867 31.1097 14.9332C34.0562 17.8797 35.7114 21.8759 35.7114 26.0428C35.7114 26.6839 35.4567 27.2988 35.0034 27.752C34.5502 28.2052 33.9353 28.46 33.2943 28.46H6.70572C6.06464 28.46 5.44984 28.2052 4.99654 27.752C4.54324 27.2988 4.28857 26.6839 4.28857 26.0428C4.28857 21.8759 5.94388 17.8797 8.89035 14.9332C11.8368 11.9867 15.8331 10.3314 20 10.3314Z",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M20 10.3314V6.70572",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M4.28857 33.2943H35.7114",
    stroke: "#ffffff",
    strokeWidth: 1.2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconServingDomeOutline);
export default __webpack_public_path__ + "static/media/icon_serving_dome_outline.a1fc18b12d6462b723f39f6677f5d830.svg";
export { ForwardRef as ReactComponent };